<template>
  <section class="lg:pl-52 border-t mx-12">
    <div class="my-6 pb-4 lg:pb-0 border-b">
      <div
        class="flex lg:items-center items-start lg:flex-row flex-col gap-y-3 gap-x-6"
      >
        <div
          class="cursor-pointer pb-1 lg:pb-6 font-medium lg:text-13px text-xs max-w-xl"
          @click="goToRoute('business-overview')"
          :class="
            route === 'business-overview'
              ? 'border-b-2 text-primary font-bold border-primary'
              : 'text-fg-muted'
          "
        >
          Business Overview
        </div>
        <el-tooltip
          class="item"
          effect="dark"
          :disabled="hasNoAdminAccess"
          :content="apiTooltipContent"
          placement="top"
        >
          <div
            class="cursor-pointer text-fg-muted pb-1 lg:pb-6 font-medium lg:text-13px text-xs max-w-xl"
            v-on="
              hasNoAdminAccess
                ? { click: () => goToRoute('security') }
                : { click: () => {} }
            "
            :class="
              route === 'security'
                ? 'border-b-2 text-primary font-bold border-primary'
                : !hasNoAdminAccess
                ? 'text-fg-muted cursor-not-allowed'
                : 'text-fg-muted'
            "
          >
            Security
          </div>
        </el-tooltip>
        <button
          v-if="tenantPermission('withdrawal-access')"
          class="text-fg-muted pb-1 lg:pb-6 font-medium lg:text-13px text-xs max-w-xl border-0 outline-none"
          v-on="
            isUserKindDeveloper
              ? {}
              : { click: () => goToRoute('withdrawal-method') }
          "
          :class="
            route === 'withdrawal-method'
              ? 'border-b-2 text-primary font-bold border-primary'
              : 'text-fg-muted'
          "
          :disabled="isUserKindDeveloper"
        >
          Withdrawal Accounts
        </button>
        <el-tooltip
          v-if="tenantPermission('api-access')"
          class="item"
          effect="dark"
          :disabled="hasApiConfig"
          :content="apiTooltipContent"
          placement="top"
        >
          <div
            class="cursor-pointer text-fg-muted pb-1 lg:pb-6 font-medium lg:text-13px text-xs max-w-xl"
            :class="{
              'cursor-not-allowed': !hasApiConfig,
              'border-b-2 text-primary font-bold border-primary': isApiKeysRoute
            }"
            v-on="hasApiAccess ? { click: () => goToRoute('api-keys') } : {}"
          >
            API Keys
          </div>
        </el-tooltip>
        <!-- <div
          class="cursor-pointer text-fg-muted pb-1 lg:pb-6 font-medium lg:text-13px text-xs max-w-xl"
          @click="goToRoute('ip-whitelisting')"
          :class="
            route === 'ip-whitelisting'
              ? 'border-b-2 text-primary font-bold border-primary'
              : 'text-fg-muted'
          "
        >
          IP Whitelisting
        </div> -->
        <div
          v-if="isUserKindOwner"
          class="cursor-pointer text-fg-muted pb-1 lg:pb-6 font-medium lg:text-13px text-xs max-w-xl"
          @click="goToRoute('user-management')"
          :class="
            route === 'user-management'
              ? 'border-b-2 text-primary font-bold border-primary'
              : 'text-fg-muted'
          "
        >
          User Management
        </div>
        <button
          v-if="
            tenantPermission('terminal-access') ||
            tenantPermission('payout-access')
          "
          class="ctext-fg-muted pb-1 lg:pb-6 font-medium lg:text-13px text-xs max-w-xl border-0 outline-none"
          v-on="
            isUserKindDeveloper
              ? {}
              : { click: () => goToRoute('beneficiaries') }
          "
          :class="
            route === 'beneficiaries'
              ? 'border-b-2 text-primary font-bold border-primary'
              : 'text-fg-muted'
          "
          :disabled="isUserKindDeveloper"
        >
          Beneficiaries
        </button>
        <div
          v-if="tenantPermission('contract-access')"
          class="cursor-pointer text-fg-muted pb-1 lg:pb-6 font-medium lg:text-13px text-xs max-w-xl"
          @click="goToRoute('contracts')"
          :class="
            route === 'contracts'
              ? 'border-b-2 text-primary font-bold border-primary'
              : 'text-fg-muted'
          "
        >
          Contracts
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import userKinds from '@/mixins/userKinds.js'
import tenant from '@/mixins/tenant.js'
import { ADMIN_BUSINESS_NAME } from '@/utils/constants'
export default {
  mixins: [userKinds, tenant],
  data () {
    return {
      apiTooltipContent:
        'Your business has not been configured for this product'
    }
  },
  computed: {
    route () {
      return this.$route.path.slice(10)
    },
    isApiKeysRoute () {
      return this.route === 'api-keys'
    },
    hasApiAccess () {
      return (
        process.env.VUE_APP_API_ACCESS === 'true' &&
        this.hasApiConfig &&
        this.tenantPermission('api-access')
      )
    },
    hasApiConfig () {
      return !!this.$store.state.auth.businessConfig.has_api_config
    },
    hasNoAdminAccess () {
      return !localStorage.getItem(ADMIN_BUSINESS_NAME)
    }
  },
  methods: {
    goToRoute (route) {
      // if (route === 'withdrawal-method' && this.isUserKindViewOnly) {
      //   this.$notify.error({
      //     title: 'Access denied',
      //     position: 'top-right'
      //   })
      // }
      this.$router.push(`/settings/${route}`)
    }
  },
  beforeMount () {
    this.adminBusinessName = localStorage.getItem(ADMIN_BUSINESS_NAME)
  }
}
</script>

<style lang="scss" scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
